import { render, staticRenderFns } from "./trade-map-image.vue?vue&type=template&id=e689f130&scoped=true&"
import script from "./trade-map-image.vue?vue&type=script&lang=js&"
export * from "./trade-map-image.vue?vue&type=script&lang=js&"
import style0 from "./trade-map-image.vue?vue&type=style&index=0&id=e689f130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e689f130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VLayout,VRow})
